import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticleGuide from "@/pages/article/kakobuy-spreadsheet-polska-kompletny-przewodnik/page";
import ArticleSafe from "@/pages/article/czy-kakobuy-jest-bezpieczny/page";
import ArticleVsSugargoo from "@/pages/article/kakobuy-vs-sugargoo/page";
import ArticleFinds2026 from "@/pages/article/najlepsze-kakobuy-finds-2026/page";
import ArticleHowWorks from "@/pages/article/jak-dziala-kakobuy-spreadsheet/page";
import ArticleShipping from "@/pages/article/kakobuy-shipping-polska/page";
import ArticleMistakes from "@/pages/article/najczestsze-bledy-kakobuy/page";
import ArticleBeginners from "@/pages/article/kakobuy-spreadsheet-dla-poczatkujacych/page";
import ArticleVsTaobao from "@/pages/article/kakobuy-vs-taobao/page";
import ArticleAlternatives from "@/pages/article/kakobuy-alternatywy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-polska-kompletny-przewodnik",
    element: <ArticleGuide />,
  },
  {
    path: "/artykul/czy-kakobuy-jest-bezpieczny",
    element: <ArticleSafe />,
  },
  {
    path: "/artykul/kakobuy-vs-sugargoo",
    element: <ArticleVsSugargoo />,
  },
  {
    path: "/artykul/najlepsze-kakobuy-finds-2026",
    element: <ArticleFinds2026 />,
  },
  {
    path: "/artykul/jak-dziala-kakobuy-spreadsheet",
    element: <ArticleHowWorks />,
  },
  {
    path: "/artykul/kakobuy-shipping-polska",
    element: <ArticleShipping />,
  },
  {
    path: "/artykul/najczestsze-bledy-kakobuy",
    element: <ArticleMistakes />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-dla-poczatkujacych",
    element: <ArticleBeginners />,
  },
  {
    path: "/artykul/kakobuy-vs-taobao",
    element: <ArticleVsTaobao />,
  },
  {
    path: "/artykul/kakobuy-alternatywy",
    element: <ArticleAlternatives />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;